export default {"src":"/_next/static/media/poolLost.79fa3a85.svg","height":24,"width":24};